export default function Cropimage(imageSrc, crop, fileName = "cropped.jpg") {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = crop.width;
      canvas.height = crop.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        image,
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        0,
        0,
        crop.width,
        crop.height
      );

      // 🔥 IMPORTANT PART
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
          }

          const file = new File([blob], fileName, {
            type: "image/jpeg",
          });

          resolve(file);
        },
        "image/jpeg",
        0.8 // ⭐ compression (80%)
      );
    };

    image.onerror = reject;
  });
}
export function generateFileName(index = 0) {
  const date = new Date();
  const dateStr = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}${String(date.getDate()).padStart(2, "0")}_${String(
    date.getHours()
  ).padStart(2, "0")}${String(date.getMinutes()).padStart(2, "0")}${String(
    date.getSeconds()
  ).padStart(2, "0")}`;
  return `uploaded_${index}_${dateStr}.jpg`;
}
